<template>
  <fragment>
    <!-- Brand accent strip -->
    <div class="mobile-nav-header">
      <div class="mobile-nav-accent" />
    </div>

    <v-list class="mobile-nav-list" nav>
      <v-list-item
        v-for="(item, index) in menuPrimary"
        :key="index"
        link
        active-class="mobile-nav-active"
        class="mobile-nav-item mb-1"
        v-bind="item.external ? {
          href: item.link,
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {
          to: localePath(item.link),
          exact: true
        }"
      >
        <v-list-item-icon class="me-3">
          <v-icon small>{{ navIcons[item.name] || 'mdi-circle-small' }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="menu-list font-weight-medium">
            {{ $t('header.' + item.name) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mx-4 my-2" />

    <v-list nav class="mobile-nav-list">
      <v-list-item exact href="https://app.motanamy.com" link class="mobile-nav-item login-item">
        <v-list-item-icon class="me-3">
          <v-icon small>mdi-login</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="menu-list font-weight-bold primary--text">
            {{ $t('header.login') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </fragment>
</template>

<style scoped lang="scss">
@import "../sidenav-style";

.mobile-nav-header {
  padding: 0;
}

.mobile-nav-accent {
  height: 4px;
  background: linear-gradient(90deg, #3f51b5, #f44336);
  border-radius: 0 0 4px 4px;
  margin-bottom: 12px;
}

.mobile-nav-list {
  padding: 4px 8px;
}

.mobile-nav-item {
  border-radius: 12px !important;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(63, 81, 181, 0.06) !important;
  }
}

.mobile-nav-active {
  background: rgba(63, 81, 181, 0.1) !important;
  color: #3f51b5 !important;

  .v-icon {
    color: #3f51b5 !important;
  }
}

.login-item {
  border: 1px solid rgba(63, 81, 181, 0.24);
  margin-top: 4px;
}
</style>

<script>
export default {
  data() {
    return {
      isOpen: false,
      navIcons: {
        feature:      'mdi-star-outline',
        services:     'mdi-briefcase-outline',
        store:        'mdi-storefront-outline',
        testimonials: 'mdi-comment-quote-outline',
        blog:         'mdi-newspaper-variant-outline',
        developers:   'mdi-code-tags',
        contact:      'mdi-email-outline',
        about:        'mdi-information-outline',
        faq:          'mdi-frequently-asked-questions',
        home:         'mdi-home-outline',
      }
    };
  },
  props: {
    menuPrimary: {
      type: Array,
      required: true
    }
  }
};
</script>
